import React from "react";
import Layout from "../components/Layout";
import Presentation from "../components/Presentation"

const indexPage = () => {
  return (
    <Layout>
      <Presentation/>
    </Layout>
  )
}

export default indexPage